<script lang="ts">
    import { getState } from "../context";
    import { createStores } from "./createContext";
    
    import {World, initialWorld} from "./world/world";
    import WorldWithButtons from "./WorldWithButtons.svelte";

    createStores();

    const state = getState();


    let world = initialWorld;

    function handleWorldChange(newWorld: World) {
        world = newWorld;
    }

    // alphabet: ['hoch', 'runter', 'stop', 'Schalter_oben', 'Schalter_unten'],
    // outputs: ['Schritt', 'rechts drehen', 'links drehen', 'Blatt legen', 'Blatt aufheben'],
</script>

<div 
    class:fullscreen={$state.fullscreen}
    style="height: 100%; display: flex; flex-direction: column;"
>
    <div
        style="display: flex; flex-direction: row;"
    >
        <div>
            Menü
        </div>
        <div>
            
        </div>
    </div>
    <div
        style="display: flex; flex-direction: row;"
    >
        <div>
            Menü
        </div>
        <div>
            <WorldWithButtons world={world} onWorldChange={handleWorldChange} />
        </div>
    </div>
</div>


<style>
    :global(.automaten-simulator-iconButton) {
        margin: 0;
        padding: 4px;
        height: 40px;
        width: 40px;
        box-sizing: border-box;

        border: 1px solid #ccc;
        border-radius: 2px;
        color: #000000;

        background-color: #f0f0f0;
    }

    :global(.automaten-simulator-iconButton:hover) {
        background-color:#d6d6d6;
    }

    .fullscreen {
        position: fixed;
        width: 100vw;
        height: 100vH;
        top: 0;
        left: 0;
        z-index: 999;
    }
</style>